import { Button } from "antd";
import React from "react";
interface ButtonPrimaryProps {
  onClick?: (event?: any) => void;
  title: string;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  style?: any;
  direction?: "rtl" | "ltr";
  loading?: boolean;
}
const PrimaryButton = ({ ...props }: ButtonPrimaryProps) => {
  return (
    <Button
      dir={props.direction}
      {...props}
      title=""
      className={`takaful--primary-button ${props.className}`}
      loading={props.loading}
    >
      {props.title.includes("ر.س") ? (
        <span className="icon-saudi_riyal">
          {props.title.replace("ر.س", "").trim()}
        </span>
      ) : (
        props.title
      )}
    </Button>
  );
};

export default PrimaryButton;
